import type { Domain } from "@piperunner-cms/types/v1";

export const DOMAINS: Record<"BLOG" | "ARTIFACT", Domain> = {
  BLOG: {
    name: "Blog",
    id: "blog",
  },
  ARTIFACT: {
    name: "Artifact",
    id: "artifact",
  },
};
